module.exports = __webpack_public_path__ + "static/media/8.3754152d.svg";